import { createStore } from 'easy-peasy';

import AppState from './AppState';
import InfoState from './InfoState';
import TooltipState from './TooltipState';

const Store = createStore({
  info: InfoState,
  app: AppState,
  tooltip: TooltipState,
});

export default Store;
